export default "__VITE_ASSET__komFmfP3__"